export class TechnicalHeaderInRequest {
  schemaName: string;
  schemaVersion: string;
  requestId: string;
  sessionId: string;
  requestingApplicationId: string;
}
